import { ssoRequest } from '@/utils/request'

export const checkProvider = domain => ssoRequest({
  url: `api/v1/identity-providers/${domain}/`,
  headers: { Accept: 'application/vnd.api+json' },
})

export default {}
